import React, {Component} from "react";
import _, { toPlainObject } from 'lodash';

import BarChart from "../BarChart/BarChart";
import ScorePreview from "./ScorePreview";

class Scores extends Component {

    hideScores = () => {
        this.props.hideScores();
    }

    state = {
        themes: this.getThemes()
    }

    getThemes() {
        let themes = [
            {
                name: 'default',
                description: 'The default theme.',
                owned: true,
                cost: 0
            },
            {
                name: 'default-light',
                description: 'The default theme, but light!',
                owned: true,
                cost: 0
            },
            {
                name: 'starlight',
                description: 'A darker theme easier on the eyes.',
                owned: localStorage.getItem('starlight') != null ? true : false,
                cost: 0
            },
            {
                name: 'otis',
                description: 'A bright colourful theme with a near white background.',
                owned: localStorage.getItem('otis') != null ? true : false,
                cost: 100
            },
            {
                name: 'luna',
                description: 'Reminiscent of a certain cat maybe?',
                owned: localStorage.getItem('luna') != null ? true : false,
                cost: 100
            },
            {
                name: 'ogre',
                description: 'Get out of my marsh!',
                owned: localStorage.getItem('ogre') != null ? true : false,
                cost: 100
            }
        ];
        themes = _.map(themes, (theme) => {
            if (theme.name === 'default') {
                theme.active = (this.props.theme === '' || this.props.theme === 'default');
            } else {
                theme.active = this.props.theme === theme.name;
            }
            return theme;
        });
        return themes;
    }

    share = (score) => {
        const data = this.getShareData(score);
        if (navigator && navigator.share && navigator.canShare(data)) {
            navigator.share(data).then(() => {
                window.dataLayer.push({'event': 'share'});
            }).catch((error) => {
                alert('Sharing failed.')
            });
        } else {
            alert('Your browser does not support sharing, this could be because you are viewing this through facebook messenger, please consider opening in chrome when you play.');
        }
    }

    getShareData = (score) => {
        let scoreEmojis = '';
        _.forEach(score.attempts, (attempt) => {
            if (attempt[0] === '')
                return false;
            _.forEach(attempt, (letter, index) => {
                if (letter === score.word[index]) {
                    scoreEmojis += '🟩';
                } else if (score.word.indexOf(letter) !== -1) {
                    scoreEmojis += '🟧'
                } else {
                    scoreEmojis += '⬛'
                }
            });
            scoreEmojis += '\n';
        });

        return {
            title: 'My GUMMIDGE score',
            text: 'I found this word in ' + score.attempt + ' attempt(s)! \n \n' + scoreEmojis + '\nTry beat my score!',
            url: 'https://gummidge.netlify.app/?word=' + score.wordID
        };
    }

    buyTheme = (theme) => {
        if (this.props.points >= theme.cost) {
            this.props.buyTheme(theme);
            let stateThemes = _.map(this.state.themes, (item) => {
                item.active = false;
                if (item.name === theme.name) {
                    item.owned = true;
                    item.active = true;
                }
                return item;
            });
            this.setState({
                themes: stateThemes
            });
            window.dataLayer.push({'event': 'buy_' + theme.name});
        }
    }
    
    setTheme = (theme) => {
        if (_.find(this.state.themes, {name: theme.name}) && _.find(this.state.themes, {name: theme.name}).owned) {
            this.props.setTheme(theme);
            let stateThemes = _.map(this.state.themes, (item) => {
                item.active = false;
                if (item.name === theme.name) {
                    item.owned = true;
                    item.active = true;
                }
                return item;
            });
            this.setState({
                themes: stateThemes
            });
            localStorage.setItem('theme', theme.name);
            window.dataLayer.push({'event': 'set_' + theme.name});
        }
    }

    render() {
        const {showScores, scores, points} = this.props;

        const scoresEntries = _.reverse(scores.map((score, index) => {
            return (
                score.success ?
                <div class="score" key={index}>
                    <ScorePreview score={score}/>
                    <div class="score-stats">
                        <p><strong>{score.word}</strong></p>
                        <p>Attempts: <strong>{score.attempt}</strong></p>
                        <p class="score-points"><strong>+{7 - score.attempt} points</strong></p>
                        {score.wordID != null ? 
                        <button class="score-share" onClick={() => {this.share(score)}}>
                            <i class="fas fa-share-square"></i> SHARE
                        </button> : <></>}
                    </div>
                </div>
                :
                <div class="score score--failed" key={index}>
                    <ScorePreview score={score}/>
                    <div class="score-stats">
                        <p><strong>{score.word}</strong></p>
                        <p><strong>LOST</strong></p>
                    </div>
                </div>
            )
        }));

        const winningGames = _.filter(scores, {success: true});
        const gamesWon = winningGames.length;
        let percentageWin = 0;
        if (scores.length > 0)
            percentageWin = Math.round((gamesWon / scores.length) * 100);


        let currentStreak = 0;
        _.forEachRight(scores, (score) => {
            if (score.success)
                currentStreak++;
            else
                return false;
        });

        let currentMaxStreak = 0;
        let maxStreak = 0;
        _.forEach(scores, (score) => {
            if (score.success)
                currentMaxStreak++;
            else {
                if (currentMaxStreak > maxStreak) {
                    maxStreak = currentMaxStreak;
                }
                currentMaxStreak = 0;
            }
            if (currentMaxStreak > maxStreak) {
                maxStreak = currentMaxStreak;
            }
        });

        let barChartData = [
            {
                name: '1',
                value: 0
            },
            {
                name: '2',
                value: 0
            },
            {
                name: '3',
                value: 0
            },
            {
                name: '4',
                value: 0
            },
            {
                name: '5',
                value: 0
            },
            {
                name: '6',
                value: 0
            }
        ]
        
        let winningData = _.map(_.groupBy(winningGames, 'attempt'), (attempts, index) => {
            return {
                name: index,
                value: attempts.length
            };
        });

        let max = 0;

        if (winningData.length > 0) {
            max = _.last(_.orderBy(winningData, 'value')).value;
        }

        barChartData = _.map(barChartData, (data) => {
            let winningDataItem = _.find(winningData, {'name': data.name});
            if (winningDataItem != null) {
                data.value = winningDataItem.value;
            }
            return data;
        });

        let themesElements = this.state.themes.map((theme, index) => {
            return (
                <div class={theme.name+'-theme theme'} key={index}>
                    <h4>{theme.name.toUpperCase()} THEME</h4>
                    <p>{theme.description}</p>
                    <div class="theme-example">
                        <div class="theme-example__correct">CORRECT</div>
                        <div class="theme-example__present">PRESENT</div>
                        <div class="theme-example__incorrect">INCORRECT</div>
                        <div class="theme-example__attempting">ATTEMPTING</div>
                    </div>
                    {
                        theme.owned === false ?
                            this.props.points >= theme.cost ?
                            <button class="buy-theme" onClick={() => this.buyTheme(theme)}><i class="fas fa-coins"></i> BUY FOR {theme.cost} POINTS</button> :
                            <button class="can-not-afford-theme" disabled="true"><i class="fas fa-piggy-bank"></i> NOT ENOUGH POINTS ({theme.cost})</button> :
                            theme.active ?
                            <p class="theme-owned">ACTIVE</p> : 
                            <button class="activate-theme" onClick={() => this.setTheme(theme)}><i class="fas fa-toggle-on"></i> ACTIVATE</button>
                                    
                    }
                </div>
            );
        });

        return (
            showScores ? 
            <div class="scores">
                <div class="hide-scores" onClick={this.hideScores}><i class="fas fa-times"></i></div>

                <h2><i class="fas fa-trophy"></i> STATS</h2>

                <strong class="points">POINTS: {points}</strong><br/><br/>

                <div class="stats">
                    <div class="stat">
                        <strong>Played</strong>
                        <span>{scores.length}</span>
                    </div>
                    <div class="stat">
                        <strong>Win %</strong>
                        <span>{percentageWin}%</span>
                    </div>
                </div>

                <div class="stats">
                    <div class="stat">
                        <strong>Current Streak</strong>
                        <span>{currentStreak}</span>
                    </div>
                    <div class="stat">
                        <strong>Best Streak</strong>
                        <span>{maxStreak}</span>
                    </div>
                </div>

                <hr/>

                <h3><i class="fas fa-chart-bar"></i> Attempt Distribution</h3>
                <p>
                    Keep track of the number of attempts it takes you to solve each word.
                </p>
                <BarChart data={barChartData} max={max}/>
                <br/>
                <hr/>

                <h3><i class="fas fa-th"></i> Themes</h3>
                <p>
                    Use your points to purchase new themes, more are on the way so it may be worth saving your points.
                </p>
                {themesElements}
                <p>
                    Earn points by finding words with the least amount of attempts, 
                    the lower the number of atempts the more points you are rewarded.
                </p>
                <br/>
                <hr/>

                <h3><i class="fas fa-gamepad"></i> Past Games</h3>
                {scoresEntries}
            </div>
            : <></>
        );
    }
}

export default Scores;